export const PLANT_DETAILS = () => {
  return {
    installationName: {
      key: "installationName",
      required: true,
      maxChar: 250,
    },
    description: {
      key: "description",
      multiline: "3",
      maxChar: 500,
    },
    city: {
      key: "city",
      maxChar: 100,
    },
  };
};

export const WATER_TYPE = (t) => {
  return [
    { label: t("waterType.seawater"), value: "Sea Water" },
    { label: t("waterType.surfaceWater"), value: "Surface Water" },
    { label: t("waterType.wellWater"), value: "Well Water" },
    { label: t("waterType.wastewater"), value: "Waste Water" },
    { label: t("waterType.roNfPermeate"), value: "RO/NF Permeate" },
    { label: t("waterType.softenedWater"), value: "Softened Water" },
    { label: t("waterType.municipalWater"), value: "Municipal Water" },
  ];
};

export const MULTIPLE_WATER_TYPE_OPTION = (t) => {
  return { label: t("ValueStrings.multiple"), value: "Multiple" };
};
